// extracted by mini-css-extract-plugin
export default {"text":"Style_text__FnZir","switch":"Style_switch__RLBLD"};